import type { FeatureRoute } from '../registry';
import { HallFloorPage } from './HallFloorPage';

export const routes: FeatureRoute[] = [{ path: 'halls/:id/floor', element: <HallFloorPage /> }];
